import loadable from '@loadable/component';

const ShBlogCommentsLazy = loadable(
    () => import('./shBlogComments')
)

export default ShBlogCommentsLazy;
